import { Helmet } from 'react-helmet-async';
import { Outlet, useLocation } from 'react-router';

import useAppNavigate from '@/shared/hooks/useAppNavigation';
import { ADMIN_ROUTES } from '@/shared/routes';
import { setAppNavigate } from '@/shared/services/helpers/navigate-helper';
import { useAppSelector } from '@/store';

import { LanguageGuard } from './language.guard';

const AppProvider: React.FC = () => {
  const { navigate } = useAppNavigate();
  const { pathname } = useLocation();
  const { headerConfig } = useAppSelector((state) => state.app);

  setAppNavigate(navigate);

  const isAdminRoute = pathname.includes(ADMIN_ROUTES.root);
  const prefix = isAdminRoute ? 'Nomad / Admin' : 'Nomad';

  return (
    <LanguageGuard>
      <Helmet titleTemplate={prefix + ' / %s'} defaultTitle={prefix}>
        <title>{headerConfig.helmetTitle}</title>
      </Helmet>
      <Outlet />
    </LanguageGuard>
  );
};

export default AppProvider;
